import React, { useEffect } from 'react';
import { useProperty } from '../../Services/hooks/PropertyCoOwn';
import { CustomSearch } from '../../Components/Form/CustomSearch';
import { PageLoader } from '../../Components/Loader/pageLoader';
import { User } from '../../Storeredux/constants/actionTypes';
import { formatCurrency } from '../../Utils/currencyFormat';
import { Pagination } from '../../Components/Pagination/pagination';
import { ReactComponent as Bed } from '../../Assets/Icons/bedcardIcon.svg';
import { ReactComponent as Shower } from '../../Assets/Icons/ShowerIcon.svg';
import { ReactComponent as Toilet } from '../../Assets/Icons/toiletIcon.svg';
import { shortenSentence } from '../../Utils/shorttenText';

function CoOwn() {
  const { getPropertyCoOwnData, loading: pageLoading, property, paginate, getFilteredPropertyData, error } = useProperty();
  const screenWidth = window.innerWidth;
  const handleSearch = async (params: any) => {
    await getFilteredPropertyData(params);
  };

  useEffect(() => {
    getPropertyCoOwnData({ type: 'all' });
  }, []);
  return (
    <div className='py-9'>
      <div className='text-center '>
        <div className={'lg:w-11/12 mx-auto bg-[#D9FCD5] rounded-xl py-7 flex flex-col gap-3.5 lg:px-16 px-8'}>
          <CustomSearch onSearch={handleSearch} />
          {error && (<p className='text-sm text-red-900 italic pt-1'>
            {error}
          </p>)}
        </div>
      </div>
      <div className='rounded-3xl w-11/12 mx-auto py-4 '>
        {pageLoading ?
          <div className='gap-7 w-fit justify-center mx-auto mt-7 flex flex-wrap h-52'>
            <PageLoader />
          </div>
          :
          <div className='gap-7 w-fit justify-between mx-auto mt-7 flex flex-wrap'>
            {property?.map((investment: User, index) => {
              return (
                <a href='https://kekere.com/register/co-own' target='_blank' key={index}
                      className={`rounded-3xl overflow-hidden lg:w-[255px] xl:w-[285px] md:w-[225px] bg-white border border-custom-grey ${screenWidth <= 390 ? 'w-[285px]' : 'w-[240px]'}`}>
                  <div className='relative'>
                    <img src={investment?.property.thumbnail} alt='investment'
                         className='w-full h-44 bg-green-200'/>
                    <span
                      className={`absolute uppercase bg-white top-2 font-semibold left-2 rounded-full text-xs py-1 px-3 ${investment?.property?.available_slots === 0 ? 'text-red-500' : 'text-green-600'}`}>
                          {investment?.property?.available_slots === 0 ? 'Sold Out' : 'Active'}
                        </span>
                  </div>
                  <div className='p-3 pb-4 flex flex-col gap-y-3'>
                    <div className={'flex gap-2 '}>
                          <span
                            className={'bg-custom-grey flex justify-between gap-3 py-1 px-2.5 w-fit rounded-3xl items-center text-xs'}>
                            <span>
                              <Bed/>
                            </span>
                            <span>{investment?.property?.details?.rooms_no}</span>
                          </span>
                      <span
                        className={'bg-custom-grey flex justify-between gap-3 py-1 px-2.5 w-fit rounded-3xl items-center text-xs'}>
                            <span>
                              <Shower/>
                            </span>
                            <span>{investment?.property?.details?.toilets_no}</span>
                          </span>
                      <span
                        className={'bg-custom-grey flex justify-between gap-3 py-1 px-2.5 w-fit rounded-3xl items-center text-xs'}>
                            <span>
                              <Toilet/>
                            </span>
                            <span>{investment?.property?.details?.toilets_no}</span>
                          </span>
                    </div>
                    <h1 className=''>{shortenSentence(investment?.property?.details?.property_title)}</h1>
                    <div>
                      <div
                        className={`w-full  rounded-full h-2 ${investment?.percent_funded === 100 ? 'bg-red-600' : 'bg-[#3AC26733]'}`}
                        style={{ mixBlendMode: 'multiply' }}>
                        <div
                          className={` h-2 rounded-full ${investment?.percent_funded === 100 ? 'bg-red-600' : 'bg-[#3AC267]'}`}
                          style={{ width: `${investment?.percent_funded}%` }}></div>
                      </div>
                      <div className={'flex justify-between w-full text-xxs text-custom-darkgreen pt-0.5'}>
                        <p>
                          {formatCurrency(investment?.amount_invested?.totalInvestedAmount)} Invested
                        </p>
                        <p>
                          {`${investment?.property?.available_slots} ${investment?.property?.available_slots === 0 ? 'slot' : 'slots'}`} remaining
                        </p>
                      </div>
                    </div>
                    <div className={'bg-[#F9F9F9] p-3 rounded-2xl flex flex-col gap-y-2 w-full'}>
                      <div className='flex justify-between text-xs'>
                        <span>Price Per Slot:</span>
                        <span
                          className={'font-semibold'}>{formatCurrency(investment?.price_per_slot)}</span>
                      </div>
                      <div className='flex justify-between text-xs'>
                        <span>Yearly Investment Return:</span>
                        <span
                          className={'font-semibold'}>{investment?.yearly_investment_return || 0}%</span>
                      </div>
                      <div className='flex justify-between text-xs'>
                        <span>Earnings On Slot:</span>
                        <span
                          className={'font-semibold'}>{formatCurrency(investment?.earning_on_slot || 0)}</span>
                      </div>
                    </div>
                  </div>
                </a>
              );
            })}
          </div>
        }
        <div className={'py-12 flex justify-end'}>
          <Pagination paginate={paginate} getPropertyCoOwnData={getPropertyCoOwnData} />
        </div>
      </div>
    </div>
  );
}

export default CoOwn;
